var _rect, _path, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _circle, _path2, _path3, _path4, _circle2, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSortToCp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 109,
    height: 109,
    rx: 11.5,
    fill: "#F8FBFF",
    stroke: "#EBF1FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.8865 50.4432L37.2464 78.6394H42.0458V50.4432H77.921V78.6394H82.7203V50.4432L83.8002 50.9231L85 48.6435L59.8034 37.125L34.4868 48.6435L35.6867 50.9231L36.8865 50.4432Z",
    fill: "#EA4141"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 43.2455,
    y: 51.6484,
    width: 32.8756,
    height: 1.19984,
    fill: "#3BAEC7"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 43.2455,
    y: 53.8047,
    width: 32.8756,
    height: 1.19984,
    fill: "#3BAEC7"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 43.2455,
    y: 55.9609,
    width: 32.8756,
    height: 1.19984,
    fill: "#3BAEC7"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 48.2849,
    y: 61.7266,
    width: 10.0786,
    height: 7.67897,
    fill: "#D9D9D9"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 48.2849,
    y: 61.7266,
    width: 10.0786,
    height: 7.67897,
    fill: "#D9D9D9"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 48.2849,
    y: 61.7266,
    width: 10.0786,
    height: 7.67897,
    fill: "#CC7848"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 59.8033,
    y: 61.7266,
    width: 10.0786,
    height: 7.67897,
    fill: "#CC7848"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 43.2455,
    y: 71.082,
    width: 10.0786,
    height: 7.67897,
    fill: "#CC7848"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 54.7639,
    y: 71.082,
    width: 10.0786,
    height: 7.67897,
    fill: "#CC7848"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 66.2823,
    y: 71.082,
    width: 10.0786,
    height: 7.67897,
    fill: "#CC7848"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 42.1428,
    cy: 48.1428,
    r: 17.1428,
    fill: "#F09C1D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9935 46.1411V42.4492H42.7839V46.1411L41.1955 45.2396L39.9935 46.1411Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31 40.6654V41.7815H51.6488V40.7727C51.6144 40.2404 51.1766 40.0358 50.9619 40H31.6654C31.2189 40.0859 31.0358 40.4794 31 40.6654Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8889 56.3582H45.8963C45.2953 55.1991 45.3526 53.6823 45.5529 53.1385C46.2398 50.434 49.0301 49.8616 50.4468 49.9618V42.4492H43.1918V47.1285L41.2171 46.0982L39.5858 47.1285V42.4492H32.0303V55.4137C31.8929 56.3753 32.5455 56.444 32.8889 56.3582Z",
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 47.5971,
    cy: 52.5971,
    r: 5.59707,
    fill: "#C63D3D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.884 49.6L50.3771 51.093C50.4687 51.1846 50.4687 51.3332 50.3771 51.4248L48.884 52.9178C48.7924 53.0094 48.6439 53.0094 48.5523 52.9178C48.4606 52.8262 48.4606 52.6777 48.5523 52.586L49.6448 51.4935H44.9828V51.0243H49.6448L48.5523 49.9318C48.4606 49.8401 48.4606 49.6916 48.5523 49.6C48.6439 49.5083 48.7924 49.5083 48.884 49.6Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.3104 56.5328L44.8174 55.0398C44.7258 54.9482 44.7258 54.7996 44.8174 54.708L46.3104 53.215C46.402 53.1234 46.5506 53.1234 46.6422 53.215C46.7338 53.3066 46.7338 53.4552 46.6422 53.5468L45.5497 54.6393H50.2117V55.1085H45.5497L46.6422 56.2011C46.7338 56.2927 46.7338 56.4412 46.6422 56.5328C46.5506 56.6245 46.402 56.6245 46.3104 56.5328Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortToCp);
export default __webpack_public_path__ + "static/media/sort-to-cp.76156d3406384ba58382137fad15aa7a.svg";
export { ForwardRef as ReactComponent };